var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"video-panel",staticClass:"bg-black flex justify-center items-center"},[_c('div',{staticClass:"video-player"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"controls":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }